module.exports = "<h3>\r\n    Alle Versionen der Medien-ID\r\n</h3>\r\n\r\n<app-table-template *ngIf=\"versions && columns\" [data]=\"versions | versionsOfMedia: showAll\" [columns]=\"columns\"></app-table-template><br>\r\n\r\n<button class=\"btn btn-default\" (click)=\"showOldVersions()\">{{showVersionsText}}</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/mediaVersion/media.version.component.html
// module id = 266
// module chunks = 1